import { EditFilled } from "@ant-design/icons";
import type { LexicalEditor, NodeKey } from "lexical";
import { useRef, useState } from "react";

const imageCache = new Set();

function useSuspenseImage(src: string) {
    if (!imageCache.has(src)) {
        throw new Promise((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                imageCache.add(src);
                resolve(null);
            };
        });
    }
}

function LazyImage({
    altText,
    className,
    imageRef,
    src,
    width,
    height,
    maxWidth
}: {
    altText: string;
    className: string | null;
    height: "inherit" | number;
    imageRef: { current: null | HTMLImageElement };
    maxWidth: number;
    src: string;
    width: "inherit" | number;
}): JSX.Element {
    useSuspenseImage(src);
    const [isOver, setIsOver] = useState(false)
    
    return (
       <>
        <img
            className={className || undefined}
            src={src}
            alt={altText}
            ref={imageRef}
            onMouseOver={()=>{
                setIsOver(true)
            }}
            style={{
                height,
                maxWidth,
                width
            }}
        />
        </>
        
    );
}

export default function ImageComponent({
    src,
    altText,
    width,
    height,
    maxWidth,
    resizable
}: {
    altText: string;
    caption: LexicalEditor;
    height: "inherit" | number;
    maxWidth: number;
    nodeKey: NodeKey;
    resizable: boolean;
    showCaption: boolean;
    src: string;
    width: "inherit" | number;
    captionsEnabled: boolean;
}) {
    const imageRef = useRef<null | HTMLImageElement>(null);

    return (
        <>
            <div>
                <LazyImage
                    className=""
                    src={src}
                    altText={altText}
                    imageRef={imageRef}
                    width={width}
                    height={height}
                    maxWidth={maxWidth}
                />
            </div>
        </>
    );
}